import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { OrganisationTagsService, SupplierService } from '../../services';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';

@Component({
  selector: 'tagging-select-supplier',
  templateUrl: 'tagging-select-supplier.component.html',
  styleUrls: ['tagging-select-supplier.component.css'],
})
export class TaggingSelectSupplierComponent implements OnInit {
  constructor(
    private supplierService: SupplierService,
    private orgTagService: OrganisationTagsService,
    private messageService: MessageService,
  ) {}

  allSuppliers: any[];
  public suppliers: any[]; // the filtered list comes from allSuppliers

  @Output() selectedSuppliersChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() removeInclusion: EventEmitter<any> = new EventEmitter<any>();

  private _selectedSuppliers: any[];
  get selectedSuppliers(): any[] {
    return this._selectedSuppliers;
  }
  set selectedSuppliers(value: any[]) {
    this._selectedSuppliers = value;

    // emit event so parent component can do something with selected suppliers
    this.selectedSuppliersChanged.emit(this._selectedSuppliers);
  }

  @Input('parentSelectedSuppliers')
  public set parentSelectedSuppliers(value: any[]) {
    this._selectedSuppliers = value;
  }
  public get parentSelectedSuppliers() {
    return this._selectedSuppliers;
  }

  public supplierFilter: {
    name: string;
    postcode: string;
    classification: string;
  } = { name: '', postcode: '', classification: '' };
  first: number = 0;

  ngOnInit() {
    this.loadSuppliers();
  }

  loadSuppliers() {
    this.supplierService.getAllForTagging().then((result) => {
      this.allSuppliers = result;
      this.suppliers = cloneDeep(result);

      //console.log("ALL SUPPLIERS: ", this.allSuppliers);

      if (
        this.supplierFilter.name != '' ||
        this.supplierFilter.classification != '' ||
        this.supplierFilter.postcode != ''
      )
        this.searchSupplier();
    });
  }

  clearSupplierFilter() {
    this.supplierFilter.classification = '';
    this.supplierFilter.name = '';
    this.supplierFilter.postcode = '';
    this.searchSupplier();
  }

  searchSupplier() {
    this.suppliers = this.allSuppliers.filter((x) => {
      return this.filterTest(x);
    });
  }

  filterTest(supplier: any): boolean {
    let result =
      (this.isNullOrEmpty(this.supplierFilter.name) ||
        supplier.name.toLowerCase().includes(this.supplierFilter.name.toLowerCase())) &&
      (this.isNullOrEmpty(this.supplierFilter.postcode) ||
        supplier.postcode.toLowerCase().includes(this.supplierFilter.postcode.toLowerCase())) &&
      (this.isNullOrEmpty(this.supplierFilter.classification) ||
        supplier.supplierOperationalData.classification
          .toLowerCase()
          .includes(this.supplierFilter.classification.toLowerCase()));

    return result;
  }

  isNullOrEmpty(s: string): boolean {
    let result = s == null || s == '' || (s != null && s.trim() == '');
    //console.log("testing string: ", s, " for null=", result);
    return result;
  }

  getOrderPreferenceDetails(orderPreference): string {
    let result: string = '';

    if (orderPreference.targetCustomerDepartment)
      result = 'Department: ' + orderPreference.targetCustomerDepartment.name;
    if (orderPreference.targetCustomerTeam)
      result = 'Team: ' + orderPreference.targetCustomerTeam.name;

    return result;
  }

  editTags(rowNode) {
    console.log('Edit tags: ', rowNode);
  }

  deleteTags(rowNode) {
    console.log('Delete tags: ', rowNode);
  }

  public getSuppliersCount() {
    let count = 0;

    if (this.suppliers) count = this.suppliers.length;

    return count.toString() + ' ' + (count == 1 ? 'Supplier' : 'Suppliers');
  }

  public refreshData() {
    this.loadSuppliers();
  }

  removeTag(tag: any) {
    this.orgTagService.removeSupplierTag(tag.id).then((res) => {
      if (!res) {
        this.messageService.add(Message.Error('This tag has been locked by network assurance'));
      } else {
        this.loadSuppliers();
      }
    });
  }

  removeCustomers() {
    this.removeInclusion.emit();
  }
}
